/**
 * FAQ Accordion Functionality
 *
 * Vanilla JavaScript implementation for FAQ accordion.
 * Uses event delegation on document for dynamically injected content (v-html).
 * Multiple accordions can be open simultaneously.
 */
(function () {
  'use strict';

  let isInitialized = false;

  /**
   * Initialize FAQ accordion functionality using document-level event delegation
   * Since content is injected via v-html in Vue, we use document-level event delegation so
   * clicks work even when content is added dynamically
   */
  function initFaqAccordion() {
    if (isInitialized) return;

    document.addEventListener('click', handleFaqClick);
    isInitialized = true;
  }

  /**
   * Handle click events on FAQ questions
   * @param {Event} event - Click event
   */
  function handleFaqClick(event) {
    const button = event.target.closest('.b-faq__question');

    if (!button) return;

    event.preventDefault();

    const isExpanded = button.getAttribute('aria-expanded') === 'true';
    const contentId = button.getAttribute('aria-controls');
    const content = document.getElementById(contentId);

    if (!content) return;

    // Toggle the accordion state
    if (isExpanded) {
      closeAccordion(button, content);
    } else {
      openAccordion(button, content);
    }
  }

  /**
   * Open an accordion item
   * @param {HTMLElement} button - The accordion button
   * @param {HTMLElement} content - The accordion content panel
   */
  function openAccordion(button, content) {
    button.setAttribute('aria-expanded', 'true');
    button.classList.add('is-expanded');
    content.hidden = false;

    // Set max-height to scrollHeight for smooth animation
    requestAnimationFrame(() => {
      content.style.maxHeight = content.scrollHeight + 'px';
    });
  }

  /**
   * Close an accordion item
   * @param {HTMLElement} button - The accordion button
   * @param {HTMLElement} content - The accordion content panel
   */
  function closeAccordion(button, content) {
    button.setAttribute('aria-expanded', 'false');
    button.classList.remove('is-expanded');

    // Ensure smooth closing
    content.style.maxHeight = content.scrollHeight + 'px';
    content.offsetHeight;
    content.style.maxHeight = '0';

    const transitionDuration = 300;
    setTimeout(() => {
      if (button.getAttribute('aria-expanded') === 'false') {
        content.hidden = true;
      }
    }, transitionDuration);
  }

  initFaqAccordion();
})();
